module.exports = __webpack_public_path__ + "static/media/Q11-10.94bdb20f.jpg";